// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Js_array from "../../../../../../../node_modules/rescript/lib/es6/js_array.js";
import * as Js_string from "../../../../../../../node_modules/rescript/lib/es6/js_string.js";
import * as Js_promise from "../../../../../../../node_modules/rescript/lib/es6/js_promise.js";

function getTrackEventPayload(payload) {
  return {
          category: payload.category,
          label: payload.label,
          value: payload.value,
          nonInteraction: payload.nonInteraction
        };
}

var moEngageEventsPrefix = [
  "fe_",
  "Verify OTP",
  "Resend",
  "Sticky",
  "Get Trip",
  "Get Estimate",
  "Login",
  "Sticky Download",
  "Frequency Selection"
];

function shouldFireMoeEvent(event_name) {
  return Js_array.some((function (event_prefix) {
                return Js_string.includes(event_prefix, event_name);
              }), moEngageEventsPrefix);
}

function setMoengageUser(moe_user_data) {
  Js_promise.then_((function (param) {
          Moengage.add_first_name(moe_user_data.first_name);
          Moengage.add_last_name(moe_user_data.last_name);
          Moengage.add_email(moe_user_data.email);
          Moengage.add_mobile(moe_user_data.mobile);
          Moengage.add_user_attribute("client_id", moe_user_data.client_id);
          Moengage.add_user_attribute("session_id", moe_user_data.session_id);
          return Promise.resolve(undefined);
        }), Moengage.add_unique_user_id(moe_user_data.customer_uuid));
}

export {
  getTrackEventPayload ,
  moEngageEventsPrefix ,
  shouldFireMoeEvent ,
  setMoengageUser ,
}
/* No side effect */
